import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { toPx } from '../utils/Styles';
import { hidden } from '../utils/propTypes/decorators';
import { SIZE_CLASSES, DIALOG_USE_CLASSES } from './DialogConstants';
const ABOVE_MOBILE_BREAKPOINT = toPx(parseInt(GRID_BREAKPOINT_SMALL, 10) + 1);
const Div = styled.div.withConfig({
  displayName: "UIDialog__Div",
  componentId: "x8a5e5-0"
})(["position:relative;width:", ";@media only screen and (min-width:", "){top:", ";}"], ({
  _dialogWidth
}) => _dialogWidth && toPx(_dialogWidth), ABOVE_MOBILE_BREAKPOINT, ({
  headerOverflow
}) => headerOverflow && toPx(headerOverflow));

class UIDialog extends Component {
  render() {
    const _this$props = this.props,
          {
      centered = false,
      children,
      className,
      use = 'default',
      size = 'medium'
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["centered", "children", "className", "use", "size"]);

    return /*#__PURE__*/_jsx(Div, Object.assign({}, rest, {
      className: classNames("private-modal uiDialog-root", DIALOG_USE_CLASSES[use], SIZE_CLASSES[size], className, centered && 'private-modal--centered'),
      children: children
    }));
  }

}

UIDialog.propTypes = {
  _dialogWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  centered: PropTypes.bool,
  children: PropTypes.node,
  headerOverflow: hidden(PropTypes.number),
  size: PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
  use: PropTypes.oneOf(Object.keys(DIALOG_USE_CLASSES))
};
UIDialog.defaultProps = {
  centered: false,
  size: 'medium',
  use: 'default'
};
UIDialog.displayName = 'UIDialog';
UIDialog.Selector = Div;
export default UIDialog;